import { DerpibooruIcon } from "components/DerpibooruIcon";
import { SubscribeStarIcon } from "components/SubscribeStarIcon";
import { MdHome, MdDraw, MdContactEmergency } from "react-icons/md";
import { SiBluesky, SiDiscord, SiMega, SiPatreon, SiX } from "react-icons/si";

export const places = [
  {
    name: "Discord server",
    link: "https://discord.gg/NsZPUMbvMN",
    icon: <SiDiscord />,
  },
  {
    name: "Twitter / X",
    link: "https://twitter.com/irisarconsfw",
    icon: <SiX />,
  },
  {
    name: "Bluesky",
    link: "https://bsky.app/profile/irisarco.art",
    icon: <SiBluesky />,
  },
  {
    name: "Derpibooru",
    link: "https://derpibooru.org/profiles/irisarco",
    icon: <DerpibooruIcon />,
  },
  {
    name: "SubscribeStar",
    link: "https://subscribestar.adult/irisarco",
    icon: <SubscribeStarIcon />,
  },
  {
    name: "Patreon",
    link: "https://patreon.com/irisarco",
    icon: <SiPatreon />,
  },
  {
    name: "Mega",
    link: "https://mega.nz/folder/cfAQhILQ#94TzcWGWK0OQMsrSBD38Ng",
    icon: <SiMega />,
  },
];

export const pages = [
  {
    title: "Home",
    path: "/",
    icon: <MdHome />,
  },
  {
    title: "Sketches",
    path: "/sketches",
    icon: <MdDraw />,
  },
  {
    title: "Commissions",
    path: "/commissions",
    icon: <MdContactEmergency />,
  },
];
